module.exports = __webpack_public_path__ + "static/media/message-read.d335a738.svg";